"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFreeShippingOfferHandler = addFreeShippingOfferHandler;
exports.dispatchAddFreeShippingOfferFailedEvent = void 0;
var AddFreeShippingOfferFailed = _interopRequireWildcard(require("@ori-events/add-free-shipping-offer-failed"));
var _checkoutUtils = require("@ori/checkout-utils");
var _types = require("../types");
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const dispatchAddFreeShippingOfferFailedEvent = detail => {
  const event = new CustomEvent(AddFreeShippingOfferFailed.Name, {
    detail
  });
  window.dispatchEvent(event);
};
exports.dispatchAddFreeShippingOfferFailedEvent = dispatchAddFreeShippingOfferFailedEvent;
async function addFreeShippingOfferHandler({
  detail: {
    itemCode,
    placement
  }
}) {
  const request = await fetch(_types.RequestUrl.AddFreeShippingOffer, (0, _utils.getHttpRequestSettings)({
    itemCode,
    placement
  }, _checkoutUtils.HttpMethod.Post));
  const response = (0, _utils.convertToCamelCase)(await request.json());
  if (AddFreeShippingOfferFailed.isAddFreeShippingOfferErrorResponse(response)) {
    dispatchAddFreeShippingOfferFailedEvent(response);
    return false;
  }
  return response;
}
//# sourceMappingURL=addFreeShippingOfferHandler.js.map